import React from 'react';
import { CardHeader } from '@material-ui/core';
import cx from 'clsx';
export var QAHeader = function (_a) {
    var title = _a.title, titleClass = _a.titleClass, avatar = _a.avatar;
    return (React.createElement(CardHeader, { title: title, titleTypographyProps: {
            className: cx(titleClass, 'faq-panel-header__title'),
            variant: 'h3',
            component: 'h3',
        }, className: cx('faq-panel-header'), avatar: avatar }));
};
//# sourceMappingURL=QAHeader.js.map